import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import banner1 from "../../../assets/images/stream.jpg";
import WaterIcon from "@mui/icons-material/Water";
import Container from "../../../common/Container";

const list = [
  {
    description: "Raising awareness on climate change issues.",
  },
  {
    description: "Implementing sustainable practices in the blue economy.",
  },
  {
    description:
      "Empowering local communities through capacity-building initiatives.",
  },
  {
    description:
      "Advocating for policy changes that support environmentally responsible practices.",
  },
];

function Impact() {
  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "15%", sm: "4%" }}>
      <Box>
        <Box position={"relative"}>
          <Box
            component="img"
            height={{ xs: "110vh", sm: "750px" }}
            display={{ xs: "none", sm: "inline" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              width: "100%",
            }}
            src={banner1}
            alt={"core-areas-image"}
          />
          <Container>
            <Box
              paddingBottom={"3%"}
              position={"absolute"}
              top={{ xs: "15%", sm: "20%" }}
              width={{ xs: "90%", sm: "75%" }}
            >
              <Typography
                variant="h6"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                paddingTop={{ xs: "28%", sm: "0%" }}
                textAlign={"left"}
              >
                <Box component={"span"}>
                  <WaterIcon
                    sx={{
                      width: 23,
                      height: 23,
                    }}
                  />
                </Box>{" "}
                Our Impact
              </Typography>
              <Typography
                variant="h3"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                textAlign={"left"}
              >
                Over the years, Blue-Echo Foundation has made significant
                strides in:
              </Typography>
              <Box>
                {list.map((lists, id) => (
                  <Box
                    key={id}
                    marginTop={{ xs: "5%", sm: "1%" }}
                    marginLeft={{ xs: "0%", sm: "0%" }}
                  >
                    <Box>
                      <Typography
                        variant={"body1"}
                        fontWeight={500}
                        textAlign={"left"}
                        paddingTop={"1%"}
                        color={"#fff"}
                      >
                        &#10004; {lists.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default Impact;
